import { createStore, applyMiddleware, combineReducers } from 'redux';
import { loginReducer } from './reducer/login-reducer';
import logger from 'redux-logger';
const rootReducer = combineReducers({
  login: loginReducer,
});
const middleWare = [logger];
export const store = createStore(rootReducer, applyMiddleware(...middleWare));
